// Features.js
import React from "react";
import { Link } from "react-router-dom";
import styles from "./Features.module.css";

const Features = () => {
  const features = [
    {
      title: "Image to WebP",
      description:
        "Convert your images into the WebP format for enhanced performance on the web.",
      path: "/image-to-webp",
      icon: "🖼️",
    },
    {
      title: "Image to PNG",
      description:
        "Convert your images into the PNG format (with transparency).",
      path: "/image-to-png",
      icon: "📄",
    },
    {
      title: "Image to JPG",
      description:
        "Convert your images into the JPG format (with adjustable quality).",
      path: "/image-to-jpg",
      icon: "🖼️",
    },
    {
      title: "Bulk Conversion Tool",
      description: "Convert multiple images at once into your desired format.",
      path: "/batch-processing",
      icon: "📦",
    },
    {
      title: "Bulk Image Compressor",
      description: "Compress multiple images at once.",
      path: "/bulk-compressor",
      icon: "🗜️",
    },
    {
      title: "Crop & Compress",
      description: "Crop your images and compress them at the same time.",
      path: "/image-crop-compress",
      icon: "✂️",
    },
  ];

  return (
    <section className={styles.featuresSection}>
      <h2 className={styles.sectionTitle}>Our Image Tools</h2>
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <Link
            key={index}
            to={feature.path}
            className={styles.featureCard}
            style={{ textDecoration: "none" }}
          >
            <div className={styles.featureIcon}>{feature.icon}</div>
            <h3 className={styles.featureTitle}>{feature.title}</h3>
            <p className={styles.featureDescription}>{feature.description}</p>
            <div className={styles.featureArrow}>→</div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Features;
